import React, { useState } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';

import EpModal from '@/comp/EPModal';

import DataExportModalContent from './DataExportModalContent';

const DataExportModal = observer(({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <>
      <EpModal open={isModalOpen} onCancel={handleCloseModal} width={'700px'} height={'580px'}>
        <DataExportModalContent handleCloseModal={handleCloseModal} />
      </EpModal>
      <Container onClick={handleOpenModal}>{children}</Container>
    </>
  );
});

const Container = styled.div`
  cursor: pointer;
`;

export default DataExportModal;
